import React from 'react'
import {Box, Button, Container} from '@mui/material'
import {useDiagnosticReport} from '../lib'
import {IconBug, IconSignOut} from '../Icons'
import {ActionHeader} from '../components'

export default function DebugPage() {
  const diag = useDiagnosticReport()
  return (
    <Container maxWidth="md">
      <ActionHeader title="Diagnostic Report" />
      <Box my={3}>
        Submitting a <Button onClick={diag.toggle}>Diagnostic Report &nbsp; <IconBug /></Button> will help resolve any issues that you are experiencing.  <Button onClick={diag.resetSession} color="primary">Resetting your session &nbsp; <IconSignOut /></Button> by logging out and logging back in may help as well.
      </Box>
      <diag.Report />
    </Container>
  )
}
